import React, { useCallback } from "react";
import { View, BackHandler } from "react-native";
import { setItem } from "@lib/storage";

import analytics from "@services/analytics";
import { IJ_EVENTS } from "@constants/analyticsEventsCT";
import { useFocusEffect, StackActions } from "@react-navigation/native";

import { PAYMENT_PENDING_MODAL, SHOW_IJ_FLOW } from "@constants/strings";
import { useDispatch } from "react-redux";
import { actions as authActions } from "@reducers/authReducer";
import Header from "./components/Header";
import MessageBox from "./components/MessageBox";

const Customer = (props) => {
  const dispatch = useDispatch();

  const onSkip = async () => {
    try {
      await setItem(SHOW_IJ_FLOW, "false");
      await setItem(
        PAYMENT_PENDING_MODAL,
        JSON.stringify(new Date().getDay() + 1),
      );
      analytics.trackEvent(IJ_EVENTS.IJ_SKIPPED, { source: "skip_btn" });
    } catch (error) {
      console.log(error);
    }
    dispatch(authActions.disableInitialJourneyWhenComplete());
  };

  return (
    <View style={{ flex: 1 }}>
      <Header />
      <MessageBox {...props} onComplete={onSkip} />
    </View>
  );
};

export default Customer;
